import { render, staticRenderFns } from "./ProductsFilter.vue?vue&type=template&id=d4e401fc&scoped=true&"
import script from "./ProductsFilter.vue?vue&type=script&lang=js&"
export * from "./ProductsFilter.vue?vue&type=script&lang=js&"
import style0 from "./ProductsFilter.vue?vue&type=style&index=0&id=d4e401fc&prod&lang=scss&"
import style1 from "./ProductsFilter.vue?vue&type=style&index=1&id=d4e401fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e401fc",
  null
  
)

export default component.exports